'use client';

import { useEffect } from 'react';

const HEAD_MARKER_ATTR = 'data-page-custom-head';

function buildExecutableScript(sourceScript, markerValue) {
    const nextScript = document.createElement('script');
    sourceScript
        .getAttributeNames()
        .forEach((attr) =>
            nextScript.setAttribute(attr, sourceScript.getAttribute(attr) || '')
        );
    nextScript.text = sourceScript.textContent || '';
    nextScript.setAttribute(HEAD_MARKER_ATTR, markerValue);
    return nextScript;
}

function buildHeadNodes(html, markerValue) {
    const template = document.createElement('template');
    template.innerHTML = html;

    return Array.from(template.content.childNodes)
        .map((node) => {
            if (node.nodeType === Node.TEXT_NODE) {
                return document.createTextNode(node.textContent || '');
            }
            if (node.nodeType !== Node.ELEMENT_NODE) return null;

            const element = node;
            const isScript =
                element.tagName &&
                element.tagName.toLowerCase &&
                element.tagName.toLowerCase() === 'script';

            const built = isScript
                ? buildExecutableScript(element, markerValue)
                : element.cloneNode(true);

            if (
                built &&
                built.nodeType === Node.ELEMENT_NODE &&
                !isScript &&
                built.setAttribute
            ) {
                built.setAttribute(HEAD_MARKER_ATTR, markerValue);
            }

            return built;
        })
        .filter(Boolean);
}

export function PageCustomCodeInjector({ headHtml = '', pageName = '' }) {
    useEffect(() => {
        const normalized = String(headHtml || '').trim();
        if (!normalized || typeof document === 'undefined') return undefined;

        const markerValue = String(pageName || 'index');
        const nodes = buildHeadNodes(normalized, markerValue);
        nodes.forEach((node) => document.head.appendChild(node));

        return () => {
            nodes.forEach((node) => {
                if (node.parentNode) node.parentNode.removeChild(node);
            });
        };
    }, [headHtml, pageName]);

    return null;
}
